<div>
  <p-dialog
    [(visible)]="displayModal"
    [draggable]="false"
    responsive="true"
    appendTo="body"
    [closeOnEscape]="!modal?.disableEsc"
    [dismissableMask]="modal?.dismissableMask"
    (onHide)="hideDialog()"
    [modal]="true"
    [styleClass]="style"
  >
    <p-header>
      <span #mod tabindex="0"></span>
      <ng-content select="[header]"></ng-content>
    </p-header>
    <ng-content></ng-content>
    <p-footer>
      <ng-content select="[footer]"></ng-content>
    </p-footer>
  </p-dialog>
</div>
